import { NotificationService } from "@/common/api.service";
import { FETCH_NOTIFICATIONS } from "./actions.type";

const state = {
  notifications: {
    counts: 0,
    items: []
  }
};

const getters = {
  notifications() {
    return state.notifications;
  }
};

const actions = {
  [FETCH_NOTIFICATIONS]({ state }, params) {
    NotificationService.list(params.ID, params)
      .then(({ data }) => {
        state.notifications = data;
      })
      .catch(error => {
        throw new Error(error);
      });
  }
};

export default {
  state,
  getters,
  actions
};
